/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import SkillBasedQueueForm from 'domain/gpo/skillBasedQueue/createupdate/SkillBasedQueueForm';
import UpdateSkillBasedQueueBreadcrumbs from 'domain/gpo/skillBasedQueue/createupdate/Update/Breadcrumbs';
import useSkillBasedQueueService from 'domain/gpo/skillBasedQueue/shared/skillBasedQueueService';
import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';

const UpdateSkillBasedQueue = () => {
  const { update, getById, getValidationSchema } = useSkillBasedQueueService();
  const { getSingleEntityUrl } = useSkillBasedQueueUrl();

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getById}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Skill Based Queue has been successfully saved.',
      }}
    >
      <UpdatePageLayout title="Edit: Skill Based Queue" breadcrumbs={<UpdateSkillBasedQueueBreadcrumbs />}>
        <SkillBasedQueueForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateSkillBasedQueue;
